import { $ } from "@/plug/Axios";

export default {
  /**
   * 测试答题分析
   */
  selfTaughtAnswerAnalyse_exportClassPractise: {
    /*
     * 导出随堂练习列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtAnswerAnalyse/exportClassPractise",
        p,
        c
      )
  },
  selfTaughtAnswerAnalyse_getByPaperAndSubject: {
    /*
     * 根据试卷和习题id查询分析
     * paperId 试卷id (integer query required)
     * subjectId 习题id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtAnswerAnalyse/getByPaperAndSubject",
        p,
        c
      )
  },
  selfTaughtAnswerAnalyse_listClassPractise: {
    /*
     * 随堂练习列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtAnswerAnalyse/listClassPractise",
        p,
        c
      )
  },
  selfTaughtAnswerAnalyse_listStudent: {
    /*
     * 学生列表
     * id id (integer query required)
     * type 类型：正确，错误 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtAnswerAnalyse/listStudent", p, c)
  },

  /**
   * 自考章节练习计划
   */
  selfTaughtChapterPlan: {
    /*
     * 添加
     * chapterIds 章节id (array query )
     * classRoomId 班级id (integer query )
     * planTime 计划时间（XXXX年XX月1号00:00:00） (string query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtChapterPlan", p, c),

    /*
     * 编辑
     * chapterId 章节id (integer query )
     * classRoomId 班级id (integer query )
     * id  (integer query )
     * planTime 计划时间（XXXX年XX月1号00:00:00） (string query )
     */
    put: (p, c) => $.put("/api/cms/selftaught/selfTaughtChapterPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtChapterPlan", p, c)
  },
  selfTaughtChapterPlan_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtChapterPlan/export", p, c)
  },
  selfTaughtChapterPlan_exportUnfinishedStudentByHeaderTeacher: {
    /*
     * 根据班主任导出未完成学员
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtChapterPlan/exportUnfinishedStudentByHeaderTeacher",
        p,
        c
      )
  },
  selfTaughtChapterPlan_exportUnfinishedStudentByPlan: {
    /*
     * 根据计划导出未完成学员
     * id 计划id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtChapterPlan/exportUnfinishedStudentByPlan",
        p,
        c
      )
  },
  selfTaughtChapterPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtChapterPlan/list", p, c)
  },
  selfTaughtChapterPlan_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtChapterPlan/upload", p, c)
  },

  /**
   * 自考班级
   */
  selfTaughtClassRoom: {
    /*
     * 添加
     * courseId 课程id (integer query )
     * id  (integer query )
     * teacherId 授课讲师 (integer query )
     * term 考期 (string query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtClassRoom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtClassRoom", p, c)
  },
  selfTaughtClassRoom_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtClassRoom/export", p, c)
  },
  selfTaughtClassRoom_getCurrentTerm: {
    /*
     * 当前考期
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/getCurrentTerm", p, c)
  },
  selfTaughtClassRoom_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtClassRoom/list", p, c)
  },
  selfTaughtClassRoom_listSimple: {
    /*
     * 简易列表
     * courseId 课程id (integer query )
     * majorId 专业id (integer query )
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/listSimple", p, c)
  },
  selfTaughtClassRoom_listSimpleByTeacher: {
    /*
     * 简易列表(讲师所负责班级)
     * courseId 课程id (integer query )
     * majorId 专业id (integer query )
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/listSimpleByTeacher", p, c)
  },
  selfTaughtClassRoom_listTerm: {
    /*
     * 考期列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtClassRoom/listTerm", p, c)
  },
  selfTaughtClassRoom_setCurrentTerm: {
    /*
     * 设置当前考期
     * term 考期 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtClassRoom/setCurrentTerm", p, c)
  },
  selfTaughtClassRoom_setTerm: {
    /*
     * 设置考期
     * terms 考期 (array query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtClassRoom/setTerm", p, c)
  },
  selfTaughtClassRoom_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtClassRoom/upload", p, c)
  },

  /**
   * 自考收藏
   */
  selfTaughtCollect: {
    /*
     * 收藏|取消收藏
     * contentId 内容id (integer query required)
     * type 类型：精品课，习题 (string query required)
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtCollect", p, c)
  },
  selfTaughtCollect_detailsForSubject: {
    /*
     * 自考习题收藏详情
     * subjectId 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCollect/detailsForSubject", p, c)
  },
  selfTaughtCollect_listChapterForSubject: {
    /*
     * 自考习题收藏列表（章节）
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCollect/listChapterForSubject", p, c)
  },
  selfTaughtCollect_listSubjectForSubject: {
    /*
     * 自考习题收藏列表（习题）
     * chapterId 章节id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCollect/listSubjectForSubject", p, c)
  },

  /**
   * 自考课程
   */
  selfTaughtCourse: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * code 课程代码 (string query )
     * cover 封面 (string query )
     * id  (integer query )
     * name 课程名字 (string query )
     * paperRule 组卷规则 (string query )
     * subjectiveAnswerWay 主观题答题方式 (string query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtCourse", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtCourse", p, c)
  },
  selfTaughtCourse_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtCourse/export", p, c)
  },
  selfTaughtCourse_getIdByName: {
    /*
     * 根据名称获取id
     * name 名称 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/getIdByName", p, c)
  },
  selfTaughtCourse_getPaperRule: {
    /*
     * 获取组卷规则
     * id 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/getPaperRule", p, c)
  },
  selfTaughtCourse_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtCourse/list", p, c)
  },
  selfTaughtCourse_listForClient: {
    /*
     * 自考精品课C端口列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/listForClient", p, c)
  },
  selfTaughtCourse_listSimple: {
    /*
     * 自考简易课程列表
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtCourse/listSimple", p, c)
  },
  selfTaughtCourse_setPaperRule: {
    /*
     * 设置组卷规则
     * id 课程id (integer query required)
     * paperRule 配置的json字符串 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtCourse/setPaperRule", p, c)
  },

  /**
   * 自考直播章节
   */
  selfTaughtLiveChapter: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * cover 封面 (string query )
     * duration 视频时长（秒） (integer query )
     * endTime 结束时间 (string query )
     * homeShow 是否主页显示 (string query )
     * id  (integer query )
     * liveUrl 直播间地址 (string query )
     * note 注意事项 (string query )
     * startTime 开始时间 (string query )
     * teacher 老师 (string query )
     * teacherAvatar 老师头像 (string query )
     * teacherSummary 老师简介 (string query )
     * title 标题 (string query )
     * videoUrl 视频地址 (string query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtLiveChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtLiveChapter", p, c)
  },
  selfTaughtLiveChapter_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtLiveChapter/list", p, c)
  },
  selfTaughtLiveChapter_listForClient: {
    /*
     * C端列表
     * courseId 课程id (integer query )
     * homeShow 是否主页展示 (string query )
     * playBack 是否回放 0 不是回放,1 是回放, 不传则返回所有 (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtLiveChapter/listForClient", p, c)
  },
  selfTaughtLiveChapter_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用禁用 (string query )
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtLiveChapter/listSimple", p, c)
  },

  /**
   * 自考试卷
   */
  selfTaughtPaper: {
    /*
     * 添加
     * ableStatus 启用状态：启用，禁用 (string query )
     * belongId 归属id,模拟考试和历年真题为课程id,课后作业为章节id (integer query )
     * classRoomId 班级id (integer query )
     * content 内容 (string query )
     * duration 建议答题时长 (string query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 试卷名称 (string query )
     * planId 教学计划id (integer query )
     * schoolRollId 学籍id,模拟考试时不为0 (integer query )
     * startTime 开始时间 (string query )
     * subjectCount 习题数量 (integer query )
     * type 类型:模拟考试，历年真题，课后作业 (string query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtPaper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtPaper", p, c)
  },
  selfTaughtPaper_content: {
    /*
     * 习题内容
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPaper/content", p, c)
  },
  selfTaughtPaper_createSimulate: {
    /*
     * 创建模拟练习
     * courseId 课程id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtPaper/createSimulate", p, c)
  },
  selfTaughtPaper_listClassPractise: {
    /*
     * 随堂练习列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listClassPractise", p, c)
  },
  selfTaughtPaper_listClassPractiseForClient: {
    /*
     * C端随堂练习列表
     * courseId 课程id (integer query required)
     * isToday 是否当天 (boolean query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtPaper/listClassPractiseForClient",
        p,
        c
      )
  },
  selfTaughtPaper_listHomework: {
    /*
     * 家庭作业列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listHomework", p, c)
  },
  selfTaughtPaper_listReal: {
    /*
     * 自考历年真题列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPaper/listReal", p, c)
  },
  selfTaughtPaper_listRealForClient: {
    /*
     * C端历年真题列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listRealForClient", p, c)
  },
  selfTaughtPaper_listSimple: {
    /*
     * 简易列表
     * classRoomId 班级id (integer query )
     * courseId 课程id (integer query required)
     * planId 班级id (integer query )
     * term 考期 (string query required)
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPaper/listSimple", p, c)
  },
  selfTaughtPaper_listSimulateForClient: {
    /*
     * C端模拟练习列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtPaper/listSimulateForClient", p, c)
  },
  selfTaughtPaper_listType: {
    /*
     * 试卷类型
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPaper/listType", p, c)
  },

  /**
   * 自考计划
   */
  selfTaughtPlan: {
    /*
     * 添加
     * batch 批次 (string query )
     * id  (integer query )
     * name 计划名称 (string query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/selftaught/selfTaughtPlan", p, c)
  },
  selfTaughtPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPlan/list", p, c)
  },
  selfTaughtPlan_listPlan: {
    /*
     * 计划名称列表
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtPlan/listPlan", p, c)
  },

  /**
   * 自考学生班级
   */
  selfTaughtStudentClassRoom_assignClass: {
    /*
     * 单个分配班级（只有覆盖模式）
     * classIds 班级id (array query required)
     * schoolRollId 学生id (integer query required)
     * term 考期 (string query )
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtStudentClassRoom/assignClass", p, c)
  },
  selfTaughtStudentClassRoom_batchAssignClass: {
    /*
     * 批量分配班级
     * assignType 类型：覆盖、增量 (string query required)
     * classIds 班级id (array query required)
     * schoolRollIds 学生id (array query required)
     * term 考期 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/batchAssignClass",
        p,
        c
      )
  },
  selfTaughtStudentClassRoom_exportAssignClass: {
    /*
     * 导出
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/exportAssignClass",
        p,
        c
      )
  },
  selfTaughtStudentClassRoom_exportByClass: {
    /*
     * 根据班级导出学生名单
     * classId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/exportByClass",
        p,
        c
      )
  },
  selfTaughtStudentClassRoom_listClassIdsByStudent: {
    /*
     * 根据学生和考期获取班级id
     * schoolRollId 合同id (integer query )
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/listClassIdsByStudent",
        p,
        c
      )
  },
  selfTaughtStudentClassRoom_listSimpleByStudent: {
    /*
     * 根据学生和考期获取班级情况
     * schoolRollId 合同id (integer query )
     * term 考期 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/listSimpleByStudent",
        p,
        c
      )
  },
  selfTaughtStudentClassRoom_uploadAssignClass: {
    /*
     * 导入分班
     * assignType 类型：覆盖、增量 (string query required)
     * excelFile excelFile (file formData required)
     * term 考期 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/uploadAssignClass",
        p,
        c
      )
  },
  selfTaughtStudentClassRoom_uploadRemoveOrCreate: {
    /*
     * 导入删除或者添加
     * classId 班级id (integer query required)
     * file file (file formData required)
     * type 类型：添加、删除 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/cms/selftaught/selfTaughtStudentClassRoom/uploadRemoveOrCreate",
        p,
        c
      )
  },

  /**
   * 自考学生练习
   */
  selfTaughtStudentExercise_exportChapter: {
    /*
     * 导出章节练习
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentExercise/exportChapter", p, c)
  },
  selfTaughtStudentExercise_exportForClassPractise: {
    /*
     * 导出随堂练习
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/exportForClassPractise",
        p,
        c
      )
  },
  selfTaughtStudentExercise_exportForClassPractiseStatics: {
    /*
     * 导出随堂练习
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/exportForClassPractiseStatics",
        p,
        c
      )
  },
  selfTaughtStudentExercise_exportForHomework: {
    /*
     * 导出课后作业
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/exportForHomework",
        p,
        c
      )
  },
  selfTaughtStudentExercise_hand: {
    /*
     * 交卷(返回练习id)
     * answers 答案 (array query required)
     * belongId 模拟练习 (integer query required)
     * courseId 课程id (integer query required)
     * exerciseTime 练习时间（秒） (integer query required)
     * subjectIds 题目id (array query required)
     * type 类型：章节练习，模拟练习，历年真题，课后作业 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtStudentExercise/hand", p, c)
  },
  selfTaughtStudentExercise_listChapter: {
    /*
     * 章节练习列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentExercise/listChapter", p, c)
  },
  selfTaughtStudentExercise_listClassPractise: {
    /*
     * 随堂练习列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/listClassPractise",
        p,
        c
      )
  },
  selfTaughtStudentExercise_listClassPractiseStatics: {
    /*
     * 随堂练习统计列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtStudentExercise/listClassPractiseStatics",
        p,
        c
      )
  },
  selfTaughtStudentExercise_listHomework: {
    /*
     * 课后作业列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentExercise/listHomework", p, c)
  },
  selfTaughtStudentExercise_read: {
    /*
     * 阅卷
     * id 练习id (integer query required)
     * level 等级 (string query required)
     * scores 分数 (array query required)
     * subjectIds 题目id (array query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtStudentExercise/read", p, c)
  },
  selfTaughtStudentExercise_restore: {
    /*
     * 修复
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtStudentExercise/restore", p, c)
  },

  /**
   * 自考学生观看章节视频记录
   */
  selfTaughtStudentVideo_exportForLive: {
    /*
     * 直播课观看记录列表导出
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/exportForLive", p, c)
  },
  selfTaughtStudentVideo_exportForVideo: {
    /*
     * 直播课观看记录列表导出
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/exportForVideo", p, c)
  },
  selfTaughtStudentVideo_history: {
    /*
     * 根据id获取观看历史记录
     * id 章节id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/history", p, c)
  },
  selfTaughtStudentVideo_listForLive: {
    /*
     * 直播课观看记录列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/listForLive", p, c)
  },
  selfTaughtStudentVideo_listForVideo: {
    /*
     * 精品课观看记录列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/listForVideo", p, c)
  },
  selfTaughtStudentVideo_progress: {
    /*
     * 修改进度，切换视频（新老视频都调用），返回，播放结束，暂停，HOME, 拖动 等情况调用
     * contentId 内容id (integer query required)
     * end 观看结束点（秒） (integer query required)
     * progress 进度 (integer query required)
     * start 观看开始点（秒） (integer query required)
     * type 类型：直播课，精品课 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtStudentVideo/progress", p, c)
  },
  selfTaughtStudentVideo_restore: {
    /*
     * 修复
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudentVideo/restore", p, c)
  },

  /**
   * 自考学习资料
   */
  selfTaughtStudyMaterials: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * docId 文档资源id (integer query )
     * id  (integer query )
     * label 标签 (string query )
     * name 名称 (string query )
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtStudyMaterials", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtStudyMaterials", p, c)
  },
  selfTaughtStudyMaterials_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudyMaterials/list", p, c)
  },
  selfTaughtStudyMaterials_listForClient: {
    /*
     * C端列表
     * courseId 课程id (integer query )
     * label 标签 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudyMaterials/listForClient", p, c)
  },
  selfTaughtStudyMaterials_listLabel: {
    /*
     * 标签列表
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtStudyMaterials/listLabel", p, c)
  },

  /**
   * 自考习题
   */
  selfTaughtSubject: {
    /*
     * 添加习题
     * ableStatus 启用状态：启用，禁用 (string query )
     * analysis 解析 (string query )
     * answer 正确答案 (string query )
     * answerA 答案A (string query )
     * answerB 答案B (string query )
     * answerC 答案C (string query )
     * answerD 答案D (string query )
     * answerE 答案E (string query )
     * answerF 答案F (string query )
     * chapterId 习题章节id (integer query )
     * content 题目 (string query )
     * contentId 内容id (integer query )
     * contentType 内容类型：单选，多选，判断等 (string query )
     * id  (integer query )
     * keywords 关键字（json字符串） (string query )
     * level 难度:简单,一般,难 (string query )
     * logicType 逻辑题型:单选，多选，判断，填空 (string query )
     * remark 备注 (string query )
     * score 分值 (number query )
     * sort 习题序号 (integer query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtSubject", p, c),

    /*
     * 编辑
     * ableStatus 启用状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=启用状态 (string query )
     * analysis 解析|列表||| (string query )
     * answer 正确答案|列表||| (string query )
     * answerA 答案A|列表||| (string query )
     * answerB 答案B|列表||| (string query )
     * answerC 答案C|列表||| (string query )
     * answerD 答案D|列表||| (string query )
     * answerE 答案E|列表||| (string query )
     * answerF 答案F|列表||| (string query )
     * content 题目|列表||| (string query )
     * contentContent 内容|列表||| (string query )
     * contentId 内容编号|全部|| (string query )
     * contentType 内容类型|列表||| (string query )
     * id 习题编号|全部||| (string query )
     * keywords 关键字|列表||| (string query )
     * level 难度|列表||| (string query )
     * logicType 逻辑类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=逻辑题型 (string query )
     * remark 备注|全部||| (string query )
     * score 分值|列表||| (number query )
     * sort 习题序号|列表||| (integer query )
     */
    put: (p, c) => $.put("/api/cms/selftaught/selfTaughtSubject", p, c)
  },
  selfTaughtSubject_details: {
    /*
     * 习题详情
     * id 习题id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/details", p, c)
  },
  selfTaughtSubject_exerciseInfo: {
    /*
     * 练习信息（全真模拟、课后作业）
     * belongId 归属id (integer query required)
     * exerciseId 练习id (integer query )
     * type 类型：历年真题、课后作业 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/exerciseInfo", p, c)
  },
  selfTaughtSubject_exerciseInfoForClient: {
    /*
     * C端练习信息
     * belongId 归属id (integer query required)
     * exerciseId 练习id (integer query )
     * type 类型：模拟考试，历年真题，课后作业，随堂练习 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/exerciseInfoForClient", p, c)
  },
  selfTaughtSubject_export: {
    /*
     * 导出习题
     * chapterId 章节id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/export", p, c)
  },
  selfTaughtSubject_info: {
    /*
     * 习题信息
     * exerciseId 练习id (integer query )
     * id 习题id (integer query required)
     * type 类型：章节练习，模拟考试，历年真题，课后作业 (string query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/info", p, c)
  },
  selfTaughtSubject_infoForClient: {
    /*
     * C端习题信息
     * exerciseId 练习id (integer query )
     * id 习题id (integer query required)
     * type 类型：章节练习，模拟考试，历年真题，课后作业 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/infoForClient", p, c)
  },
  selfTaughtSubject_list: {
    /*
     * 列表
     * chapterId 章节id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/selftaught/selfTaughtSubject/list", p, c)
  },
  selfTaughtSubject_listByCourseAndRemark: {
    /*
     * 根据课程和备注，获取自考章节习题列表
     * chapterIds 章节id (array query )
     * contentType 内容类型 (string query )
     * courseId 课程id (integer query required)
     * remark 备注 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/listByCourseAndRemark", p, c)
  },
  selfTaughtSubject_listChapterSubjectForClient: {
    /*
     * C端章节习题列表
     * chapterId 章节id (integer query required)
     * exerciseId 练习id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/selftaught/selfTaughtSubject/listChapterSubjectForClient",
        p,
        c
      )
  },
  selfTaughtSubject_listContentType: {
    /*
     * 获取题型列表
     * chapterIds 章节id (array query )
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/listContentType", p, c)
  },
  selfTaughtSubject_listForDailyExercise: {
    /*
     * 每日一练习题
     * chapterIds 章节id (array query )
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubject/listForDailyExercise", p, c)
  },
  selfTaughtSubject_uploadByExcel: {
    /*
     * 上传章节习题(Excel)
     * chapterId 章节id (integer query required)
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtSubject/uploadByExcel", p, c)
  },
  selfTaughtSubject_uploadByWord: {
    /*
     * 上传章节习题(Word)
     * chapterId 章节id (integer query required)
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtSubject/uploadByWord", p, c)
  },

  /**
   * 自考习题章节
   */
  selfTaughtSubjectChapter: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * id  (integer query )
     * name 章节名称 (string query )
     * sort  (integer query )
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtSubjectChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtSubjectChapter", p, c)
  },
  selfTaughtSubjectChapter_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubjectChapter/list", p, c)
  },
  selfTaughtSubjectChapter_listForClient: {
    /*
     * C端列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubjectChapter/listForClient", p, c)
  },
  selfTaughtSubjectChapter_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用禁用 (string query )
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtSubjectChapter/listSimple", p, c)
  },

  /**
   * 自考视频章节
   */
  selfTaughtVideoChapter: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * duration 视频时长（秒） (integer query )
     * id  (integer query )
     * name 章节名称 (string query )
     * sort  (integer query )
     * videoUrl 视频地址 (string query )
     */
    post: (p, c) => $.post("/api/cms/selftaught/selfTaughtVideoChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtVideoChapter", p, c)
  },
  selfTaughtVideoChapter_batchAble: {
    /*
     * 批量启用禁用
     * ableStatus 启用状态：启用，禁用 (string query required)
     * ids 章节id (array query required)
     */
    put: (p, c) =>
      $.put("/api/cms/selftaught/selfTaughtVideoChapter/batchAble", p, c)
  },
  selfTaughtVideoChapter_batchRemove: {
    /*
     * 批量删除
     * ids 知识点id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtVideoChapter/batchRemove", p, c)
  },
  selfTaughtVideoChapter_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtVideoChapter/list", p, c)
  },
  selfTaughtVideoChapter_listForClient: {
    /*
     * C端列表
     * courseId 课程Id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtVideoChapter/listForClient", p, c)
  },
  selfTaughtVideoChapter_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用禁用 (string query )
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtVideoChapter/listSimple", p, c)
  },

  /**
   * 错题集
   */
  selfTaughtWrongSubject: {
    /*
     * 移除
     * subjectId 习题id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/selftaught/selfTaughtWrongSubject", p, c)
  },
  selfTaughtWrongSubject_batchAdd: {
    /*
     * 批量添加错题（每日一练）
     * answers 答案 (array query required)
     * subjectIds 习题id (array query required)
     */
    post: (p, c) =>
      $.post("/api/cms/selftaught/selfTaughtWrongSubject/batchAdd", p, c)
  },
  selfTaughtWrongSubject_details: {
    /*
     * 自考错题集详情
     * subjectId 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtWrongSubject/details", p, c)
  },
  selfTaughtWrongSubject_listChapter: {
    /*
     * 自考错题集列表（章节）
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtWrongSubject/listChapter", p, c)
  },
  selfTaughtWrongSubject_listSubject: {
    /*
     * 自考错题集列表（习题）
     * chapterId 章节id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/selftaught/selfTaughtWrongSubject/listSubject", p, c)
  }
};
